import { updateBalance } from "../../functions/Functions_General";
import { PopupMessageBox } from "../../messageBox";
import { CommonData } from "../../datastructures/gamestate/gameData";

export class PopUpFreeSpin //extends Popper
{
    private parent :PIXI.Container;
    private activeGameData:CommonData;
    private messageBox:PopupMessageBox;
    private displayResult:boolean;
    // private isOpen:boolean;

    
    constructor(parent:PIXI.Container,activeGameData:CommonData)
    {   
      //  super(activeGameData);
        this.parent= new PIXI.Container();
        parent.addChild(this.parent); 
        this.activeGameData=activeGameData;
        this.messageBox= new PopupMessageBox(1,this.activeGameData.size,this.activeGameData);
        this.messageBox.setHeadText(this.activeGameData.gameTextGeneral.congrats);
        this.messageBox.setBodyText(this.activeGameData.gameTextGeneral.msgFS2+" "+this.activeGameData.freeSpinsCount+" "+this.activeGameData.gameTextGeneral.fs+"!");
        // this.messageBox.setChildOf(this.parent);
        
        this.messageBox.setMessageBoxVisibile(false);
        this.messageBox.setLabel(0,this.activeGameData.gameTextGeneral.msgFSBtn1);
        this.messageBox.setButtons(0,this.closeMessage.bind(this));
        this.displayResult=false;
        this.parent.alpha=0;
        this.messageBox.setMessageBoxPosY(this.activeGameData.size[1]/2-350/2); 
        // this.isOpen=false;
    }


    private displayWinMessage()
    {   
        // console.log("displayFreeSpin")

       if(this.activeGameData.freeSpinsWinning>0)
       {
        this.messageBox.setHeadText(this.activeGameData.gameTextGeneral.congrats);
       }
       else
       {
        this.messageBox.setHeadText(""); 
       }
     
        this.messageBox.setBodyText(this.activeGameData.gameTextGeneral.fs+" "+this.activeGameData.gameTextGeneral.winnings +": \n " +this.activeGameData.freeSpinsWinning.toFixed(2) +" "+this.activeGameData.currency);
        this.messageBox.setLabel(0,this.activeGameData.gameTextGeneral.continue);
    }

    private displayDefault()
    {
        this.messageBox.setHeadText(this.activeGameData.gameTextGeneral.congrats);
        this.messageBox.setBodyText(this.activeGameData.gameTextGeneral.msgFS2+" "+this.activeGameData.freeSpinsCount+" "+this.activeGameData.gameTextGeneral.fs+"!");
        this.messageBox.setLabel(0,this.activeGameData.gameTextGeneral.msgFSBtn1);
        
    }

    public setVisibility=(bool:boolean):void=>
    {   
        var i = bool ? 1 : 0;
        if(bool)
        {   
            if(this.displayResult)
            {
                this.displayWinMessage(); //update message to display
                this.displayResult=false;
            }
            else{
                this.displayResult=true;
                this.displayDefault();
    
            }
            this.activeGameData.disableAllBtns(this.activeGameData);

        }

        this.parent.alpha=i;
        this.messageBox.setMessageBoxVisibile(bool);
    }

    private closeMessage=():void=>
    {
        this.messageBox.setMessageBoxVisibile(false);
        this.activeGameData.freeSpinsActive=false;
        if(this.activeGameData.betResponse.playerBalance.creditsBalance !=undefined)
        {   
            // if(this.activeGameData.betResponse.gameContext.win>0)
            // {
                updateBalance(this.activeGameData);
            // }
       
        }
        this.activeGameData.resetAllBtns(this.activeGameData);
    }

    public removeFromCanvas=():void=>
    {
        this.closeMessage();
    }

    public getIsOpen=():boolean=>
    {
        // return this.isOpen;
        return this.messageBox.getIsOpen();
    }
}
